import { useContext, useMemo } from 'react';
import { AlertContext } from './context';

const useAlert = () => {
  const context = useContext(AlertContext);
  if (context === undefined) {
    throw new Error('useAlert must be used within an AlertProvider');
  }

  const { alertsVisible, alertMessage, setAlertMessage, setAlertsVisible } = context;

  // Currently assume that only a single alert will be visible at all times. May need to throw out logic
  // and rewrite if multiple alerts are needed.
  return useMemo(
    () => ({
      alertsVisible,
      showSuccess(text: string, id?: string) {
        setAlertMessage({ severity: 'success', text, id });
        setAlertsVisible(true);
      },
      showWarning(text: string, id?: string) {
        setAlertMessage({ severity: 'warning', text, id });
        setAlertsVisible(true);
      },
      showError(text: string, id?: string) {
        setAlertMessage({ severity: 'error', text, id });
        setAlertsVisible(true);
      },
      closeErrors() {
        if (alertMessage?.severity === 'error') {
          setAlertsVisible(false);
        }
      },
      closeWarning() {
        if (alertMessage?.severity === 'warning') {
          setAlertsVisible(false);
        }
      },
      closeAlerts() {
        setAlertsVisible(false);
      },
    }),
    [setAlertMessage, setAlertsVisible, alertsVisible]
  );
};

export default useAlert;
